import { Card, ClickAwayListener, Popper, Tooltip } from '@mui/material';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { CancelWhiteIcon, DeleteMessageIcon, DeliveredIcon, DownloadMediaIcon, DuplicateIcon, EditIcon, ForwardMessageIcon, ForwordDark, HistoryCheckIcon, HistoryExclamatoryIcon, HistoryTimerIcon, MessageAiSearch, MessageSeenIcon, PartialStatusIcon, ResumeIcon, ScheduleGray, SecureChatDownloadActiveIcon, SecureChatDownloadGreyIcon, SettingsHorizIcon, StopIcon, SuggestedRepliesIcon } from '../../icon';
import { Contact, ConversationCardModel, DeliveryStatus, RecipientStatusList, SENT_VIA_API } from '../../models/conversations';
import { ScheduleMessageType, SecureScheduleMessageStatus } from '../../models/conversations/schedule-messages.model';
import { mapToReport, ReportsModel } from '../../models/reports.model';
import { MediaModel } from '../../models/templates.models';
import { UserModel } from '../../models/users.model';
import * as selector from '../../selectors/selectors';
import { FileService } from '../../services/FileService';
import { MessageService } from '../../services/MessageService';
import { UtilityService } from '../../services/UtilityService';
import { appNote, AutomationRulesLabel, buildResolvedTags } from '../shared/constants';
import MediaComponent from "../shared/media/media.component";
import Mention from '../shared/mentions';
import MessageReportPopover from './messageReportPopover';
import MessageScheduleInfo from './scheduleMessageInfo';
import { useLocation } from 'react-router';
import { SettingsModel } from '../../models/settings-model';
import { MenuItemRender } from '../shared/menu-item-render';
import { SecureChatService } from '../../services/SecureChatService';
import Confirm_Dialog from '../shared/confirm-dialog.component';
import setToast from '../../helpers/toaster.helper';
import { ToasterType } from '../shared/toaster/toaster.model';


interface IProps {
    MessageData: any;
    OpenForwardMessage: (media: MediaModel, msg: string) => void;
    CardData?: ConversationCardModel;
    onEditScheduleChange?: (value: boolean, id?: any) => void;
    DuplicateSchedule?: (scheduleID: string, participantId?: string) => void;
    IsSecureChat?: boolean;
    OpenSuggestedReplies?: (messageData: any) => void;
    selectedMessageForSuggestion?: string;
}

const DisplayConversation = (props: IProps) => {
    const dispatch = useDispatch()
    const location = useLocation()
    const TrainedAiFiles: any[] = useSelector(selector.AiTrainedFiles)
    const TrainedAiUrls: any[] = useSelector(selector.AiTrainedUrls)
    const IsMobileDevice: boolean = useSelector(selector.isMobileDevice);
    const AllUsers: UserModel[] = useSelector(selector.allUsers);
    const Contacts: Contact[] = useSelector(selector.contacts);
    const Settings: SettingsModel = useSelector(selector.settingsObj)
    const IdDarkMode: boolean = useSelector(selector.isDarkMode)
    const customAttributeFields = useSelector(selector.customAttributeFields)
    const resolvedTags = useMemo(() => buildResolvedTags(customAttributeFields), [customAttributeFields])
    const [campaignMessageReport, setCampaignMessageReport] = useState<ReportsModel>()
    const [openReport, setOpenReport] = useState<boolean>(false)
    const [loadingReports, setLoadingReports] = useState<boolean>(false)
    const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
    const [SelectedScheduleType, SetSelectedScheduleType] = useState<number>(props.MessageData.ScheduleType);
    const [ScheduleDateTime, SetScheduleDateTime] = useState<number | string>(props.MessageData.MessageDateTime);
    const [showCalnder, setShowCalnder] = useState<boolean>(true);
    const [message, setMessage] = useState<string>(props.MessageData.Message)
    const [editSchedule, setEditSchedule] = useState<boolean>(false)
    const [isVisible, setIsVisible] = useState(false);
    const [operationType, setOperationType] = useState<"update" | "delete">();
    const [showConfirm, setShowConfirm] = useState<boolean>(false);
    const [confirmText, setConfirmText] = useState<string>("");

    const [downloadIconActive, setDownloadIconActive] = useState<boolean>(false)
    const [anchorE2, setAnchorE2] = useState<HTMLButtonElement | null>(null);

    const handlePopoverOpen = (event: any) => {
        setAnchorEl(event.currentTarget);
    };

    const handlePopoverClose = () => {
        setAnchorEl(null);
    };

    const { IsOutbound, Message, Media, FromPhoneNumber, MessageDateTime, GroupChat, SenderID, Campaign, ConversationAuditId, CampaignId } = props.MessageData;

    useEffect(() => {
        SetScheduleDateTime(props.MessageData.MessageDateTime)
        setMessage(props.MessageData.Message)
        SetSelectedScheduleType(props.MessageData.ScheduleType)
    }, [props.MessageData.MessageDateTime, props.MessageData.Message, props.MessageData.ScheduleType])

    useEffect(() => {
        setIsVisible(true);
    }, []);

    const getUserName = (senderId: string) => {
        let data = AllUsers.find((x) => x.ID === senderId);
        if (data) {
            let name = data.FirstName + " " + data.LastName.charAt(0).toUpperCase() + data.LastName.slice(1).toLowerCase();
            return UtilityService.trimMessage(name, 20)
        }
        else if (senderId === AutomationRulesLabel.SENDERID) {
            return AutomationRulesLabel.AUTOMATED_REPLY
        }
        else if (senderId === SENT_VIA_API.SENDERID) {
            return SENT_VIA_API.SENT_VIA_API_TEXT
        }
    }

    const getGroupChatUserName = (number: string) => {
        var data = Contacts.find((x) => x.PhoneNumber === number);
        if (!!data) {
            let name = data?.Name;
            return UtilityService.trimMessage(name, 17)
        }
        else if (data === undefined) {
            return UtilityService.maskPhoneNumberOnLength(number)
        }
    }

    const getCampaignMessageReport = (id) => {
        setLoadingReports(true)
        MessageService.getCampaignMessageReport(id)
            .then(result => {
                setLoadingReports(false)
                setCampaignMessageReport(mapToReport(result.data))
                setOpenReport(true)
            }).catch((error) => {
                console.log(error)
                setLoadingReports(false)
            })
    }

    const openPopover = Boolean(anchorEl);
    let ScheduleTypes = [
        { Name: "One time", Value: ScheduleMessageType.ONE_TIME }
        , { Name: "Daily", Value: ScheduleMessageType.DAILY }
        , { Name: "Weekly", Value: ScheduleMessageType.WEEKLY }
        , { Name: "Monthly", Value: ScheduleMessageType.MONTHLY }
    ];

    const handleSelectChange = (event) => {
        SetSelectedScheduleType(Number(event.target.value));
    };
    const showClander = (isboolen) => {
        setShowCalnder(isboolen)
    }

    const handleeditSchedule = () => {
        setEditSchedule(true)
        props.onEditScheduleChange(true, props.MessageData?.ID)
    }

    const handelopenPopper = (event: any) => {
        setAnchorE2(event.currentTarget);
    };

    const handleClickAway = () => {
        setAnchorE2(null);
    }

    const toBase64 = (file: any) => new Promise<any>((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });

    const stopOrResume = () => {

        let text = props.MessageData.Status === SecureScheduleMessageStatus.STOPPED ? appNote.SCHEDULED_MESSAGE_RESUME : appNote.SCHEDULED_MESSAGE_STOP;
        setConfirmText(text)
        setShowConfirm(true)
        setOperationType("update")

    }

    const deleteSchedule = () => {

        setConfirmText(appNote.SCHEDULED_MESSAGE_DELETE)
        setShowConfirm(true)
        setOperationType("delete")

    }

    const optionData =
        [{
            Name: "Edit",
            Icon: EditIcon,
            OnClick: () => { props.onEditScheduleChange(true, props.MessageData?.ID) },
        },
        {
            Name: props.MessageData?.Status === SecureScheduleMessageStatus.STOPPED ? "Resume" : "Stop",
            Icon: props.MessageData?.Status === SecureScheduleMessageStatus.STOPPED ? ResumeIcon : StopIcon,
            OnClick: () => { stopOrResume() },
        },
        {
            Name: "Duplicate",
            Icon: DuplicateIcon,
            OnClick: () => { props.DuplicateSchedule(props.MessageData?.ID, props.CardData.ID) },
        },
        {
            Name: "Delete",
            Icon: DeleteMessageIcon,
            OnClick: () => { deleteSchedule() },
        }]


    const confirm = async (confirm, e) => {

        if (confirm) {

            if (operationType === "update") {

                let content = []
                let mediapayload = []

                if (props.MessageData.Media?.length) {
                    mediapayload = await Promise.all(
                        props.MessageData.Media.map(async (file) => {
                            let value: string;
                            let type: string;

                            // if (!file.file) {
                            const blob = await FileService.getBlobFromUrl(file?.Url);
                            type = blob.type;
                            const base64String = await toBase64(blob);
                            value = base64String.split(",")[1];
                            // } else {
                            //     value = (file.media?.Url || "").split(",")[1];
                            //     type = (file.file as any).type;
                            // }

                            return {
                                type: type,
                                file_name: file?.Name,
                                value,
                                payload: {}
                            };
                        })
                    )
                }

                if (!!mediapayload?.length) {
                    content = mediapayload
                }
                if (props.MessageData.Message) {
                    let msgpayload = {
                        type: "text",
                        value: props.MessageData.Message,
                        payload: {}
                    }
                    content = [...content, msgpayload]
                }

                const editdata = {
                    content: content,
                    status: props.MessageData.Status === SecureScheduleMessageStatus.STOPPED ? SecureScheduleMessageStatus.SCHEDULED : SecureScheduleMessageStatus.STOPPED,
                    schedule_type: props.MessageData.ScheduleType,
                    next_send_time: new Date(props.MessageData.MessageDateTime).getTime()
                }

                SecureChatService.updateScheduleMessage(props.MessageData.ID, editdata).then((res) => {
                    setShowConfirm(false);
                    setConfirmText("")
                    setToast(res.data.message, ToasterType.SUCCESS);
                }).catch((err) => {
                    setShowConfirm(false);
                    setConfirmText("")
                    setToast("Update Schedule Failed", ToasterType.DANGER)
                })

            }

            if (operationType === "delete") {

                SecureChatService.deleteScheduleMessage(props.MessageData.ID).then((res) => {
                    setShowConfirm(false);
                    setConfirmText("")
                    setToast("schedule deleted successfully", ToasterType.SUCCESS)
                }).catch(() => {
                    setShowConfirm(false);
                    setConfirmText("")
                    setToast("schedule deletion failed", ToasterType.DANGER)
                })

            }
        }
        else {
            setShowConfirm(false);
            setConfirmText("");
        }

    }


    return (
        <div className={``}>
            {props.IsSecureChat && ScheduleDateTime && props.MessageData.ScheduleType && <div className="d-flex justify-flex-end w-p-100">
                <MenuItemRender MenuData={optionData} MeetBallIcon={SettingsHorizIcon} ClassName={"pr-4"} Data={props.MessageData} />
            </div>
            }
            <div className='d-flex align-end'>
                <div className={`d-flex w-p-100 open-more-options align-center ${IsOutbound ? "justify-flex-end" : ""}`}>
                    {/* {IsOutbound &&
                        props.IsSecureChat
                        &&
                        <div className='d-flex align-center h-p-100 mr-2 pt-1' onMouseEnter={() => { setDownloadIconActive(true) }} onMouseLeave={() => { setDownloadIconActive(false) }}>
                            {Media &&
                                <>
                                    {
                                        downloadIconActive ?
                                            <SecureChatDownloadActiveIcon className='c-pointer' onClick={() => { FileService.fileDownload(Media) }} />
                                            :
                                            <SecureChatDownloadGreyIcon className='c-pointer' />
                                    }
                                </>
                            }
                        </div>
                    } */}

                    {IsOutbound &&
                        !props.IsSecureChat
                        &&
                        <div className='d-flex display-more-options'>
                            {props.CardData.msgType !== "secure-chat" && <Tooltip title={"Forward"} placement="top">
                                <ForwardMessageIcon className="icon-primary p-1 br-50" onClick={() => props.OpenForwardMessage(Media, message)} />
                            </Tooltip>
                            }
                        </div>
                    }

                    <div ref={(el) => {
                        if (el && SelectedScheduleType !== undefined && IsMobileDevice) {
                            el.style.setProperty('max-width', "none", 'important');
                        }
                    }
                    } className={`animate ${isVisible ? 'expanded' : ''} p-1 my-1 h5-regular ${IsOutbound ? "outboundmsg mr-1" : props.selectedMessageForSuggestion === props.MessageData.ID ? "replySuggestedMessage" : "inboundmsg"}`}>
                        <div className={`color-conversation-history-msg footnote ${IsOutbound ? "  d-flex justify-between" : ""}`}>
                            <span className={`${IsOutbound ? "mr-1" : ""}`}>{IsOutbound ? getUserName(SenderID) : getGroupChatUserName(FromPhoneNumber)}</span>
                            <span style={{ marginLeft: (props.MessageData.GroupChat || props.MessageData.GroupChatId || location?.pathname.includes("secure-chat")) ? "10px" : "" }}>
                                {props.MessageData?.BundleId ? UtilityService.convertToDateTimeFormat(MessageDateTime) : UtilityService.convertToTimeFormat(MessageDateTime)}
                            </span>
                        </div>
                        {Media?.length > 0 ?
                            <div>
                                {/* {props.IsSecureChat ?
                                    <>
                                        <div className='h5-medium d-flex align-center my-1'>
                                            <div>
                                                <SecureChatMediaIcon className='h-3 mr-1' />
                                            </div>
                                            <div>
                                                {Media.Name}
                                            </div>
                                        </div>
                                    </>
                                    : */}
                                <>
                                    {Media?.map(Media => <MediaComponent Media={Media} NoDownloadOption={props.IsSecureChat && IsOutbound} SenderName={IsOutbound ? getUserName(SenderID) : getGroupChatUserName(FromPhoneNumber)}
                                        IsSecureChat={props.IsSecureChat || props.CardData?.msgType === "secure-chat"} IsEndUserSideSecureChat={location.pathname.includes("/falkon/secure-chat")}
                                        ConversationId={props.CardData?.ID} />)}
                                    <Mention IsGroupChat={!!GroupChat?.ID} body={message} tags={resolvedTags} emoji={''} openTags={false} tagTarget={undefined} onChange={() => { }} onKeyDown={() => { }} closeTags={() => { }} maxLength={message?.length} id={''} placeholder={''} readOnly={true} IsOutbound={IsOutbound} IsLinkAllowed={true} />
                                    <MessageScheduleInfo
                                        scheduleIcon={props.MessageData?.ScheduleIcon}
                                        selectedScheduleType={SelectedScheduleType}
                                        scheduleTypes={ScheduleTypes}
                                        scheduleDateTime={ScheduleDateTime}
                                        onScheduleTypeChange={handleSelectChange}
                                        onShowCalendarClick={() => showClander(true)}
                                        campaignId={CampaignId}
                                        handlePopoverOpen={handlePopoverOpen}
                                        getCampaignMessageReport={getCampaignMessageReport}
                                        conversationAuditId={ConversationAuditId}
                                        CardData={props.CardData}
                                        onclick={handleeditSchedule}
                                    />
                                </>

                            </div>
                            :
                            <>
                                <Mention IsGroupChat={!!GroupChat?.ID} IsCampaign={!!Campaign?.ID} body={message} tags={resolvedTags} emoji={''} openTags={false} tagTarget={undefined} onChange={() => { }} onKeyDown={() => { }} closeTags={() => { }} maxLength={message?.length} id={''} placeholder={''} readOnly={true} IsOutbound={IsOutbound} IsLinkAllowed={true} />
                                <MessageScheduleInfo
                                    scheduleIcon={props.MessageData?.ScheduleIcon}
                                    selectedScheduleType={SelectedScheduleType}
                                    scheduleTypes={ScheduleTypes}
                                    scheduleDateTime={ScheduleDateTime}
                                    onScheduleTypeChange={handleSelectChange}
                                    onShowCalendarClick={() => showClander(true)}
                                    campaignId={CampaignId}
                                    handlePopoverOpen={handlePopoverOpen}
                                    getCampaignMessageReport={getCampaignMessageReport}
                                    conversationAuditId={ConversationAuditId}
                                    CardData={props.CardData}
                                    onclick={() => handleeditSchedule()}
                                />
                            </>
                        }
                        <MessageReportPopover
                            open={openPopover}
                            onClose={handlePopoverClose}
                            anchorEl={anchorEl}
                            loadingReports={loadingReports}
                            campaignMessageReport={campaignMessageReport}
                            IsMobileDevice={IsMobileDevice}
                        />
                    </div>

                    {/* {!IsOutbound &&
                        props.IsSecureChat
                        &&
                        <div className='d-flex align-center h-p-100 ml-2 pt-1' onMouseEnter={() => { setDownloadIconActive(true) }} onMouseLeave={() => { setDownloadIconActive(false) }}>
                            {Media &&
                                <>
                                    {downloadIconActive ?
                                        <SecureChatDownloadActiveIcon className='c-pointer' onClick={() => { FileService.fileDownload(Media) }} />
                                        :
                                        <SecureChatDownloadGreyIcon className='c-pointer' />
                                    }
                                </>
                            }
                        </div>
                    } */}

                    {!IsOutbound &&
                        !props.IsSecureChat
                        &&
                        <div className='d-flex display-more-options'>
                            {props.CardData.msgType !== "secure-chat" && <Tooltip title={"Forward"} placement="top">
                                {IdDarkMode ? <ForwordDark className="icon-primary  p-1 br-50" onClick={() => props.OpenForwardMessage(Media, message)} /> : <ForwardMessageIcon className="icon-primary  p-1 br-50" onClick={() => props.OpenForwardMessage(Media, message)} />}
                            </Tooltip>
                            }
                            {!props.IsSecureChat && props.CardData.msgType !== "secure-chat" && Settings.Settings?.find(x => x.Code === "AI")?.Value?.toString()?.toLowerCase() === "true" && (!!TrainedAiFiles.length || !!TrainedAiUrls.length) &&
                                <Tooltip title={"Suggested Replies"} placement="top">
                                    {IdDarkMode ? <MessageAiSearch className=" icon-primary p-1 br-50 " onClick={() => { props.OpenSuggestedReplies(props.MessageData) }} /> : <SuggestedRepliesIcon className="  p-1 br-50 pb-2 pl-1 w-3 h-3" onClick={() => { props.OpenSuggestedReplies(props.MessageData) }} />}
                                </Tooltip>
                            }
                        </div>
                    }
                </div>
                {IsOutbound && !props.MessageData?.BundleId &&
                    <div>
                        {props.MessageData?.ScheduleIcon ? <span><ScheduleGray className="mr-1 mb-1" /></span> :
                            props.MessageData.DeliveryStatus === DeliveryStatus.SENDING ? // waiting for signalr event
                                <span><HistoryTimerIcon className="mr-1 mb-1" /></span> :
                                props.MessageData.DeliveryStatus === DeliveryStatus.PENDING ? // message sent but not deliverd
                                    <span><HistoryCheckIcon className="mr-1 mb-1" /></span> :
                                    props.MessageData.DeliveryStatus === DeliveryStatus.SENT ? //message deliverd
                                        <DeliveredIcon className={`mr-1 mb-1 ${!!props.CardData?.GroupChat ? "c-pointer" : ""}`} onClick={(e) => !!props.CardData?.GroupChat && handelopenPopper(e)} /> :
                                        props.MessageData.DeliveryStatus === DeliveryStatus.READ ? //message read
                                            <span><MessageSeenIcon className="mr-1 mb-1" /></span> :
                                            props.MessageData.DeliveryStatus === DeliveryStatus.RECEIVED ? //message read
                                                <span><DeliveredIcon className="mr-1 mb-1" /></span> :
                                                props.MessageData.DeliveryStatus === DeliveryStatus.PARTIALLYSENT ?
                                                    <PartialStatusIcon className={`mr-1 mb-1 ${!!props.CardData?.GroupChat ? "c-pointer" : ""}`} onClick={(e) => !!props.CardData?.GroupChat && handelopenPopper(e)} />
                                                    : <span><HistoryExclamatoryIcon className={`mr-1 mb-1 ${!!props.CardData?.GroupChat ? "c-pointer" : ""}`} onClick={(e) => !!props.CardData?.GroupChat && handelopenPopper(e)} /></span>// message failed
                        }
                    </div>
                }

            </div>
            {
                props.MessageData?.ScheduleIcon &&
                <div className='d-flex justify-flex-end w-p-100 mb-1'>
                    <div className='pr-4 h6-regular'>
                        Scheduled for <span onClick={handleeditSchedule} className='h6-medium t-decoration-underline c-pointer'>{UtilityService.convertToDateWithWeekFormat(props.MessageData.MessageDateTime).split(', ').slice(1).join(', ')}</span> at <span onClick={handleeditSchedule} className='h6-medium c-pointer t-decoration-underline'>{UtilityService.convertToTimeFormat(props.MessageData.MessageDateTime)}</span>
                    </div>
                </div>
            }

            {
                <Confirm_Dialog Show={showConfirm} onClose={confirm} Text={confirmText} ButtonName={operationType === "update" ? props.MessageData.Status === SecureScheduleMessageStatus.STOPPED ? "Resume" : "Stop" : "Delete"} />
            }

            {
                <Popper open={Boolean(anchorE2)} anchorEl={anchorE2} placement='left-end' className={`${IsMobileDevice ? "pb-1" : "pb-1 pr-1"}`}>
                    <ClickAwayListener onClickAway={handleClickAway}>
                        <Card className=' br-2'>
                            <div className='bg-color-primary-btn d-flex  h4-medium color-secondary p-2 d-flex justify-between align-center min-w-40 w-p-94'>
                                <span className='w-p-80'>
                                    Message status Information
                                </span>
                                <CancelWhiteIcon className='w-2 h-2 c-pointer' onClick={handleClickAway} />
                            </div>
                            <div className={`bg-color-secondary ${IsMobileDevice ? "p-1" : "p-2"}`} >
                                {!!props.MessageData.RecipientStatusList?.length ?
                                    <div className='groupchat-info-background groupchat-info-border p-2 br-1'>
                                        <div className=' d-flex  h4-regular color-accent pb-1 '>
                                            <span className={`${IsMobileDevice ? "w-18" : "w-20"} `}>
                                                Name
                                            </span>
                                            <span className={`${IsMobileDevice ? "w-18" : "w-20"} `}>
                                                Phone Number
                                            </span>
                                            <span>
                                                Status
                                            </span>
                                        </div>
                                        {props.MessageData.RecipientStatusList.map((x) =>
                                            <div className='d-flex pb-1 h5-regular color-accent w-p-100'>
                                                <div className={`${IsMobileDevice ? "w-18" : "w-20"} `}>
                                                    {!!Contacts.find((y) => y.PhoneNumber === x.PhoneNumber)?.Name ? UtilityService.trimMessage(Contacts.find((y) => y.PhoneNumber === x.PhoneNumber).Name, 15) : "--"}
                                                </div>
                                                <div className={`${IsMobileDevice ? "w-18" : "w-20"} `}>
                                                    {UtilityService.maskPhoneNumberOnLength(x.PhoneNumber)}
                                                </div>
                                                <div className=' d-flex justify-center align-center'>
                                                    {x.Status === DeliveryStatus.PENDING ?
                                                        <span className='color-primary-warning'>Sent</span> :
                                                        x.Status === DeliveryStatus.SENT ?
                                                            <span className='color-primary-success'>Delivered</span>
                                                            : <span className='color-primary-danger'>Failed</span>
                                                    }
                                                </div>
                                            </div>
                                        )}
                                    </div> :
                                    <div className='t-align-center h4-regular w-word w-40'>
                                        Delivery status isn't available for messages sent before May 28.
                                    </div>
                                }
                            </div>
                        </Card>
                    </ClickAwayListener>
                </Popper>
            }
        </div >
    )
}

export default DisplayConversation;